import React from 'react';
import { Link } from 'react-router-dom';
import { keywords, siteName } from './keywords'; // Import keywords and siteName

function KeywordsDisplay() {
  React.useEffect(() => {
    document.title = `Wszystkie kebaby | ${siteName}`; // Set title for the main list page
  }, []);

  return (
    <div className="keywords-container"> {/* Reusing the class from your CSS */}
      <h1>Kupując kebaba, osiedlasz araba!</h1>
      <p>Wybierz nazwę kebaba, aby dowiedzieć się więcej. Każdy kebab ma swoją stronę.</p>
      <ul>
        {keywords.map((keyword) => (
          <li key={keyword.id}>
            {/* Link to the dedicated page for each keyword */}
            <Link to={`/kebab/${keyword.id}`}>{keyword.name}</Link>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default KeywordsDisplay;
